<div class="row">
    <div class="col-md-6 col-lg-3"><img src="assets/img/vacio1.png" alt=""></div>
    <div class="col-md-6 col-lg-3"><img src="assets/img/vacio1.png" alt=""></div>
    <div class="col-md-6 col-lg-3"><img src="assets/img/vacio1.png" alt=""></div>
    <div class="col-md-6 col-lg-3"><img src="assets/img/vacio1.png" alt=""></div>
</div>
<div class="row">
    <div class="col-md-6 col-lg-4"><img src="assets/img/vacio3.png" alt=""></div>
    <div class="col-md-6 col-lg-4"><img src="assets/img/vacio3.png" alt=""></div>
    <div class="col-md-6 col-lg-4">
        <h2 class="titleppal">un mundo de servicios</h2><img src="assets/img/vacio2.png" alt=""></div>
</div>